export const isFieldReadOnly = (data, fieldPath) => {
  /*
   * NOTE:  It may look odd to default to read only, but we don't want to make a decision until the accounting
   *        integrations have finished loading.  -- Jonathan Byrne 12/27/2021
   */
  if (!data?.accountingIntegrations) {
    return true;
  }
  const accountingIntegrations = data.accountingIntegrations.filter(
    accountingIntegration => accountingIntegration.accountingIntegrationField.path === fieldPath
  );

  return accountingIntegrations.length > 0;
};
